import React, {lazy} from 'react';
import { Redirect } from 'react-router';

import Auth from '../services/auth';

const Error403 = lazy(() => import('../pages/error/error-403'));

const auth = new Auth();
const isAuthenticated = auth.isAuthenticated();

const AuthGuard = ChildComponent => props => {
  
  const checkAuthorized = () =>{
    let {path} = props.match;
    const pathArray = path.split('/');
    const lastPath = pathArray[pathArray.length -1];
    if((lastPath === 'detail') || (lastPath === 'form') || (lastPath === 'list-menu')){
      pathArray.pop(); //remove lastPath
      path = pathArray.join("/");
    }else if ((lastPath === 'loan') && (pathArray[pathArray.length -2] === 'detail')){
      pathArray.pop(); //remove lastPath
      pathArray.pop(); //remove beforeLastPath
      path = pathArray.join("/");
    }
    
    const menuAccess = localStorage.getItem("menu-access");
    const isAuthorized = menuAccess?.includes(path) || (path === "/user/profile");
    return isAuthorized;
    // return true;
  } 

  return (
    isAuthenticated ? checkAuthorized() ? <ChildComponent {...props}/> : <Error403/> : <Redirect to='/login'/> 
  );
}

export default AuthGuard;